import * as m from '../../localization/out/messages.js';

// ? is this something for engine?
export const translateEnum = (prefix: string, et?: string) => {
  if (!et) return '';
  const fn = (m as any)[`${prefix}_${et}`];
  return typeof fn === 'function' ? fn() : et;
};
